import { object, null as zNull } from "zod";

export const disconnectWayfairIntegration = {
  name: "disconnectWayfairIntegration" as const,
  input: object({}),
  output: zNull(),
};
